// Styles
import './herobanner.scss';
import { headerHeight } from '../../scripts/helpers';

if (!window.dAgency) window.dAgency = {};
window.dAgency.initHerobanner = (context) => {
  const herobannerSection = context.closest('.shopify-section');


  if (herobannerSection) {
    const herobannerContainer = herobannerSection.querySelector('.herobanner__container');

    const heroBannerHeight = () => {
      const doc = document.documentElement
      doc.style.setProperty('--hero-banner-height', `${window.innerHeight - headerHeight()}px`)
    }

    const getSectionMaxHeight = () => {
      if (window.innerWidth <= 768) {
        heroBannerHeight()
      }else{
        herobannerContainer.style.maxHeight = `calc(100vh - ${headerHeight()}px)`;
        window.addEventListener('resize', () => {
          herobannerContainer.style.maxHeight = `calc(100vh - ${headerHeight()}px)`;
        });
      }
    };

    getSectionMaxHeight();
  }
}

if(document.readyState != "loading") {
  [].forEach.call(document.querySelectorAll('.herobanner__container'), (el) => {
    window.dAgency.initHerobanner(el);
  });
} else {
  document.addEventListener('DOMContentLoaded', () => {
    [].forEach.call(document.querySelectorAll('.herobanner__container'), (el) => {
      window.dAgency.initHerobanner(el);
    });
  });
}
